// code: ["A", "B", "C", "B", "B", "A"],
// chip: ["마감재", "집기", "마네킨", "영상", "간판/로고", "설비/누수/소방", "전기/조명", "음향", "기타"],

import moment from "moment";
import { useEffect, useState } from "react";
import { useAppSelector } from "src/store/actions/action";

// code: ["1201000", "1202000", "1203000", "1206000", "1207000", "1208000", "1204000", "1205000", "1209000"],
const typeJSON = {
  마감재: "1201000",
  집기: "1202000",
  마네킨: "1203000",
  영상: "1206000",
  "간판/로고": "1207000",
  "설비/누수/소방": "1208000",
  "전기/조명": "1204000",
  음향: "1205000",
  기타: "1209000",
  백화점: "A",
  대리점: "B",
  직영점: "C",
  아울렛: "O",
  팩토리: "B",
  면세점: "ADF",
  MLB: "M",
  "MLB KIDS": "I",
  Discovery: "X",
  "STRETCH ANGELS": "A",
  DUVETICA: "V",
  SUPRA: "W",
  "Sergio Tacchini": "ST",
  "1개월": "1",
  "3개월": "3",
  "6개월": 6,
  "12개월": 12,
  최신순: "DESC",
  오래된순: "ASC",
  가나다순: "ASC",
  제목순: "ASC",
  매장명순: "ASC",
  별점높은순: "DESC",
  별점낮은순: "ASC",
  이행률높은순: "DESC",
  이행률낮은순: "ASC",
  접수중: "as_20",
  업체배정: "as_40",
  견적진행: "as_60",
  "A/S진행": "as_80",
  완료: "as_100",
  취소: "as_0",
  0: "as_0",
  20: "as_20",
  40: "as_40",
  60: "as_60",
  80: "as_80",
  100: "as_100",
  일반공지: "1301000",
  "마네킨 착장": "1302000",
  매장연출: "1303000",
  "영상 ": "1304000",
  비주얼: "1305000",
  "기타 ": "1306000",
  이행: "Y",
  미이행: "N",
  "평가 전": "N",
  "평가 완료": "Y",
};

const brandToCode = (brand: string) => {
  switch (brand) {
    case "Discovery":
      return "X";
    case "MLB":
      return "M";
    case "MLB KIDS":
      return "I";
    case "STRETCH ANGELS":
      return "ST";
    case "DUVETICA":
      return "V";
    case "SUPRA":
      return "W";
    case "Sergio Tacchini":
      return "ST";
  }
};

const categoryGroup: any = {
  store: [],
  brand: [],
  date: [],
  category: [],
  process: [],
  manageSort: "",
  page: 0,
  contents: "",
  asSort: "",
  newStore: "",
  myExecute: "",
  fulfillSort: "",
  fulfillStore: [],
  execute: "",
  reExecute: "",
  assess: "",
};

// 페이지 값이 숫자여서 다른 검색에 숫자가 있으면 안됨
// 값에 따라 array 배열 분기하여 등록
// typeSearchArray에 유형전체 데이터를 배열로 가지고옴
// contentsSearchString, sortSearchString, pageSearchNumber 요소 하나씩 가지고 옴
// pattern

const categoryGroupClass = (key: any, value: any) => {
  // filter.insert_date=$btw:2022-03-02,2022-03-02&filter.storeTypeCode.code_id=$in:A,B&search=롯&sortBy=open_date:ASC
  //   let queryFilter = "";
  if (key) {
    //typeSearchArray
    if (key === "typeSearchArray") {
      if ("백화점_대리점_직영점_아울렛_팩토리_면세점".indexOf(value) > -1) {
        //   queryFilter = "filter.storeTypeCode.code_id=$in:";
        categoryGroup.store.push(value);
      } else if ("MLB_MLB KIDS_Discovery_STRETCH ANGELS_DUVETICA_SUPRA_Sergio Tacchini".indexOf(value) > -1) {
        //   queryFilter = "filter.brand=$in:";
        categoryGroup.brand.push(value);
      } else if ("마감재_집기_마네킨_영상_간판/로고_설비/누수/소방_전기/조명_음향_기타_일반공지_매장연출_마네킨 착장_영상 _비주얼_기타 _".indexOf(value) > -1) {
        //   queryFilter = "filter.cate_idx=$in:";
        categoryGroup.category.push(value);
      } else if (String(value).indexOf("개월") > -1) {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if (String(value) === "기간선택") {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if ("접수중_업체배정_견적진행_A/S진행_완료_취소".indexOf(value) > -1) {
        categoryGroup.process.push(value);
      }
    } else if (key === "fulfillSearch") {
      if ("백화점_대리점_직영점_아울렛_팩토리_면세점".indexOf(value) > -1) {
        //   queryFilter = "filter.store_user.store_type=$in:";
        categoryGroup.fulfillStore.push(value);
      } else if ("이행_미이행".indexOf(value) > -1) {
        categoryGroup.execute = value;
      } else if ("평가 전_평가 완료".indexOf(value) > -1) {
        categoryGroup.assess = value;
      }
    }
    // else if (key === "processSearchArray") {
    //   categoryGroup.process.push(value);
    // }
    else if (key === "contentsSearchString") {
      categoryGroup.contents = value;
    } else if (key === "sortSearchString") {
      categoryGroup.manageSort = value;
    } else if (key === "asSortSearchString") {
      categoryGroup.asSort = value;
    } else if (key === "fulfillSortSearchString") {
      categoryGroup.fulfillSort = value;
    } else if (key === "pageSearchNumber") {
      categoryGroup.page = value;
    } else if (key === "newStoreSearchString") {
      categoryGroup.newStore = value;
    } else if (key === "reExecuteSearchString") {
      categoryGroup.reExecute = value;
    } else if (key === "myExecuteSearchString") {
      categoryGroup.myExecute = value;
    }
  }
};

const commaMark = (i: number, lastLength: number) => {
  let comma = "";
  if (i !== lastLength - 1) {
    comma = ",";
  }
  return comma;
};

const quaterTrans = (quaterValue: string) => {
  let returnQuater = "&";
  if (quaterValue === "?") {
    returnQuater = "&";
  } else if (quaterValue === "") {
    returnQuater = "?";
  }
  return returnQuater;
};

const urlReplace = (url: string) => {
  url = url.replace(/&/g, "%26").replace(/\+/g, "%2B");
  return url;
};

// 쿼리스트링 메인
const setQueryStringVer = (params: any, searchStartDate?: string, searchEndDate?: string, apiType?: string) => {
  // 글로벌 변수를 초기화
  categoryGroup.store = [];
  categoryGroup.brand = [];
  categoryGroup.date = [];
  categoryGroup.category = [];
  categoryGroup.process = [];
  categoryGroup.manageSort = "";
  categoryGroup.asSort = "";
  categoryGroup.fulfillSort = "";
  categoryGroup.page = 0;
  categoryGroup.contents = "";
  categoryGroup.newStore = "";
  categoryGroup.myExecute = "";
  categoryGroup.fulfillStore = [];
  categoryGroup.execute = "";
  categoryGroup.assess = "";
  // JSON 데이터를 받아서 처리
  const objectToStrong = JSON.stringify(typeJSON);
  const stringToJSON = JSON.parse(objectToStrong);
  let returnString = "";
  let quater = "";

  Object.entries(params).map((object: any, index: number) => {
    const key = object[0];
    const mapObject = object[1];
    // 배열
    if (typeof mapObject === "object") {
      if (mapObject.length > 0) {
        for (let i = 0; i < mapObject.length; i++) {
          categoryGroupClass(key, mapObject[i]);
        }
      }
    }
    if (typeof mapObject === "string") {
      if (mapObject !== "") {
        categoryGroupClass(key, mapObject.trim());
      } else {
        categoryGroupClass(key, "");
      }
    }
    if (typeof mapObject === "number") {
      if (mapObject !== 0) {
        categoryGroupClass(key, mapObject);
      }
    }
  });

  if (categoryGroup.store.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.store_type=$in:";
    for (let i = 0; i < categoryGroup.store.length; i++) {
      returnString += stringToJSON[categoryGroup.store[i]] + commaMark(i, categoryGroup.store.length);
      //   if(i === (categoryGroup.store.length-1)){
      //   }else{
      //     returnString += stringToJSON[categoryGroup.store[i]] + ",";
      //   }
    }
  }

  if (categoryGroup.brand.length > 0) {
    if (apiType === "as") {
      quater = quaterTrans(quater);
      returnString += quater + "filter.store_user.brand=$in:";
      const temp = categoryGroup.brand.map((res: string) => brandToCode(res));
      returnString += temp.join(",");
    } else {
      quater = quaterTrans(quater);
      returnString += quater + "filter.brand=$in:";
      console.log(categoryGroup.brand);
      for (let i = 0; i < categoryGroup.brand.length; i++) {
        returnString += stringToJSON[categoryGroup.brand[i]] + commaMark(i, categoryGroup.brand.length);
      }
    }
  }

  if (categoryGroup.category.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.cate_idx=$in:";
    for (let i = 0; i < categoryGroup.category.length; i++) {
      returnString += stringToJSON[categoryGroup.category[i]] + commaMark(i, categoryGroup.category.length);
    }
  }

  if (categoryGroup.date.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.insert_date=$btw:";
    for (let i = 0; i < categoryGroup.date.length; i++) {
      if (categoryGroup.date[i] === "기간선택") {
        console.log("searchStartDate===============", searchStartDate);
        returnString += searchStartDate + "," + searchEndDate;
      } else {
        const startDate = moment().subtract(stringToJSON[categoryGroup.date[i]], "month").format("YYYY-MM-DD");
        // nestJS btw조건은 = 조건 포함 안되어서 react에서 하루 추가하여 데이터를 찾는다
        const result = new Date();
        result.setDate(result.getDate() + 1);
        const endDate = moment(result).format("YYYY-MM-DD");
        returnString += startDate + "," + endDate;
      }
    }
  }

  if (categoryGroup.process.length > 0) {
    quater = quaterTrans(quater);
    // 취소건이 생기면서 필터링 변경
    // returnString += quater + "filter.progress=$in:";
    returnString += quater + "filter.search_progress=$in:";
    for (let i = 0; i < categoryGroup.process.length; i++) {
      returnString += stringToJSON[categoryGroup.process[i]] + commaMark(i, categoryGroup.process.length);
    }
  }

  if (categoryGroup.manageSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=open_date:";
    } else if ("가나다순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=name:";
    } else if ("별점높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("별점낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("이행률높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    } else if ("이행률낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    }
    returnString += stringToJSON[categoryGroup.manageSort];
  }

  if (categoryGroup.asSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=insert_date:";
    } else if ("가나다순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=contents:";
    } else if ("제목순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=title:";
    }
    returnString += stringToJSON[categoryGroup.asSort];
  }

  if (categoryGroup.fulfillSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.fulfillSort) > -1) {
      returnString += quater + "sortBy=insert_date:";
    } else if ("매장명순".indexOf(categoryGroup.fulfillSort) > -1) {
      returnString += quater + "sortBy=store_user.name:";
    } else if ("별점높은순".includes(categoryGroup.fulfillSort)) {
      returnString += quater + "sortBy=score:";
    } else if ("별점낮은순".includes(categoryGroup.fulfillSort)) {
      returnString += quater + "sortBy=score:";
    }
    returnString += stringToJSON[categoryGroup.fulfillSort];
  }

  if (categoryGroup.newStore !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "newStore=" + categoryGroup.newStore;
  }

  if (categoryGroup.myExecute !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "myExecute=" + categoryGroup.myExecute;
  }

  if (categoryGroup.page !== 0) {
    quater = quaterTrans(quater);
    returnString += quater + "page=" + categoryGroup.page;
  }

  if (categoryGroup.contents !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "search=" + urlReplace(categoryGroup.contents);
  }

  if (categoryGroup.fulfillStore.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.store_user.store_type=$in:";
    for (let i = 0; i < categoryGroup.fulfillStore.length; i++) {
      returnString += stringToJSON[categoryGroup.fulfillStore[i]] + commaMark(i, categoryGroup.fulfillStore.length);
    }
  }

  if (categoryGroup.execute.length > 0) {
    quater = quaterTrans(quater);
    if ("이행_미이행".indexOf(categoryGroup.execute) > -1) {
      returnString += quater + "filter.execute_yn=$eq:";
    }
    returnString += stringToJSON[categoryGroup.execute];
  }

  if (categoryGroup.assess.length > 0) {
    quater = quaterTrans(quater);
    if ("평가 전_평가 완료".indexOf(categoryGroup.assess) > -1) {
      returnString += quater + "filter.assess_yn=$eq:";
    }
    returnString += stringToJSON[categoryGroup.assess];
  }

  if (categoryGroup.reExecute !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "filter.re_execute_yn=$eq:" + categoryGroup.reExecute;
  }

  return returnString;
};

export default setQueryStringVer;
